export const latinFlashcards = {
  categories: [
    {
      la: "Salve!",
      rm: "Sal-veh!",
      en: "Hello!",
    },
    {
      la: "Salvēte!",
      rm: "Sal-veh-teh!",
      en: "Hello! (to more than one person)",
    },
    {
      la: "Quid agis?",
      rm: "Kwid a-gis?",
      en: "How are you? (informal)",
    },
    {
      la: "Quid agitis?",
      rm: "Kwid a-gi-tis?",
      en: "How are you? (to more than one person, informal)",
    },
    {
      la: "Quid agis hodiē?",
      rm: "Kwid a-gis ho-dee-eh?",
      en: "How are you today?",
    },
    {
      la: "Bene sum, gratias.",
      rm: "Beh-neh soom, grah-tee-ahs.",
      en: "I am well, thank you.",
    },
    {
      la: "Male sum.",
      rm: "Mah-leh soom.",
      en: "I am not well.",
    },
    {
      la: "Gratias tibi ago.",
      rm: "Grah-tee-ahs tee-bee a-go.",
      en: "Thank you.",
    },
    {
      la: "Gratias maximas!",
      rm: "Grah-tee-ahs mahk-see-mahs!",
      en: "Thank you very much!",
    },
    {
      la: "Libenter.",
      rm: "Lee-ben-ter.",
      en: "You're welcome.",
    },
    {
      la: "Si placet.",
      rm: "See plah-ket.",
      en: "Please.",
    },
    {
      la: "Ignosce mihi.",
      rm: "Ig-nos-keh mee-hee.",
      en: "Excuse me. / Forgive me.",
    },
    {
      la: "Mihi ignosce.",
      rm: "Mee-hee ig-nos-keh.",
      en: "Excuse me. (more direct)",
    },
    {
      la: "Ita.",
      rm: "Ee-tah.",
      en: "Yes.",
    },
    {
      la: "Minime.",
      rm: "Mee-nee-meh.",
      en: "No.",
    },
    {
      la: "Domus mea illic est.",
      rm: "Do-moos meh-ah il-leek est.",
      en: "My house is over there.",
    },
    {
      la: "Ubi est latrina?",
      rm: "Oo-bee est lah-tree-nah?",
      en: "Where is the toilet?",
    },
    {
      la: "Quanti constat?",
      rm: "Kwan-tee kon-stat?",
      en: "How much does it cost?",
    },
    {
      la: "Nimis carum est!",
      rm: "Nee-mis kah-room est!",
      en: "It's too expensive!",
    },
    {
      la: "Auxilium!",
      rm: "Owk-see-lee-oom!",
      en: "Help!",
    },
    {
      la: "Medicus!",
      rm: "Meh-dee-koos!",
      en: "Doctor!",
    },
    {
      la: "Viam errāvi.",
      rm: "Vee-ahm er-rah-vee.",
      en: "I've lost my way.",
    },
    {
      la: "Hoc volo.",
      rm: "Hok vo-lo.",
      en: "I want this.",
    },
    {
      la: "Hoc nolo.",
      rm: "Hok no-lo.",
      en: "I don't want this.",
    },
    {
      la: "Quid est nomen tibi?",
      rm: "Kwid est no-men tee-bee?",
      en: "What is your name?",
    },
    {
      la: "Mihi nomen est...",
      rm: "Mee-hee no-men est...",
      en: "My name is...",
    },
    {
      la: "Valde bene!",
      rm: "Val-deh beh-neh!",
      en: "Very good!",
    },
    {
      la: "Hoc mihi placet.",
      rm: "Hok mee-hee plah-ket.",
      en: "I like this.",
    },
    {
      la: "Hoc mihi non placet.",
      rm: "Hok mee-hee non plah-ket.",
      en: "I don't like this.",
    },
    {
      la: "Esne Americanus/Americana?",
      rm: "Es-neh A-meh-ree-kah-nus/A-meh-ree-kah-nah?",
      en: "Are you American? (male/female)",
    },
    {
      la: "Esne peregrinus/peregrina?",
      rm: "Es-neh peh-reh-gree-nus/peh-reh-gree-nah?",
      en: "Are you a tourist? (male/female)",
    },
    {
      la: "Adiuva me, si vis.",
      rm: "Ad-yoo-vah meh, see vees.",
      en: "Help me, if you please.",
    },
    {
      la: "Loquere lentius, si vis.",
      rm: "Lo-kweh-reh len-tee-oos, see vees.",
      en: "Speak more slowly, please.",
    },
    {
      la: "Iterum dic, si vis.",
      rm: "Ee-teh-room deek, see vees.",
      en: "Say that again, please.",
    },
    {
      la: "Aeger sum.",
      rm: "Eh-ger soom.",
      en: "I am sick.",
    },
    {
      la: "Medicum quaero.",
      rm: "Meh-dee-koom kwah-ro.",
      en: "I need a doctor.",
    },
    {
      la: "Hoc nimis magnum est.",
      rm: "Hok nee-mis mahg-noom est.",
      en: "This is too big.",
    },
    {
      la: "Hoc nimis parvum est.",
      rm: "Hok nee-mis par-voom est.",
      en: "This is too small.",
    },
    {
      la: "Hoc mihi da.",
      rm: "Hok mee-hee dah.",
      en: "Give me this.",
    },
    {
      la: "Hoc ostende mihi.",
      rm: "Hok os-ten-deh mee-hee.",
      en: "Show me this.",
    },
    {
      la: "Quid hoc significat?",
      rm: "Kwid hok see-gnee-fee-kat?",
      en: "What does this mean?",
    },
    {
      la: "Ubi est taberna?",
      rm: "Oo-bee est tah-ber-nah?",
      en: "Where is the shop/tavern?",
    },
    {
      la: "Ubi est caupona?",
      rm: "Oo-bee est cow-po-nah?",
      en: "Where is the inn?",
    },
    {
      la: "Cras.",
      rm: "Kras.",
      en: "Tomorrow.",
    },
    {
      la: "Hodiē.",
      rm: "Ho-dee-eh.",
      en: "Today.",
    },
    {
      la: "Nunc.",
      rm: "Nunk.",
      en: "Now.",
    },
    {
      la: "Postea.",
      rm: "Pos-teh-ah.",
      en: "Later.",
    },
    {
      la: "Quid novi?",
      rm: "Kwid no-vee?",
      en: "What's new?",
    },
    {
      la: "Nihil novi.",
      rm: "Nee-heel no-vee.",
      en: "Nothing new.",
    },
    {
      la: "Felix dies!",
      rm: "Feh-leeks dee-es!",
      en: "Have a good day!",
    },
    {
      la: "Felix nox!",
      rm: "Feh-leeks noks!",
      en: "Have a good night!",
    },
    {
      la: "Vale!",
      rm: "Wah-leh!",
      en: "Goodbye! / Be well!",
    },
    {
      la: "Valete!",
      rm: "Wah-leh-teh!",
      en: "Goodbye! (to more than one person)",
    },
    {
      la: "Ad dextram.",
      rm: "Ad deks-trahm.",
      en: "To the right.",
    },
    {
      la: "Ad sinistram.",
      rm: "Ad see-nees-trahm.",
      en: "To the left.",
    },
    {
      la: "Rectā ite.",
      rm: "Rek-tah ee-teh.",
      en: "Go straight.",
    },
    {
      la: "Prope.",
      rm: "Pro-peh.",
      en: "Near.",
    },
    {
      la: "Longe.",
      rm: "Lon-geh.",
      en: "Far.",
    },
    {
      la: "Esne certus/certa?",
      rm: "Es-neh ker-toos/ker-tah?",
      en: "Are you sure? (male/female)",
    },
    {
      la: "Certus sum/Certa sum.",
      rm: "Ker-toos soom/Ker-tah soom.",
      en: "I am sure. (male/female)",
    },
    {
      la: "Nescio.",
      rm: "Nes-kee-oh.",
      en: "I don't know.",
    },
    {
      la: "Hoc est bonum.",
      rm: "Hok est bo-noom.",
      en: "This is good.",
    },
    {
      la: "Hoc est malum.",
      rm: "Hok est mah-loom.",
      en: "This is bad.",
    },
    {
      la: "Non est problema.",
      rm: "Non est pro-bleh-mah.",
      en: "No problem.",
    },
    {
      la: "Cave!",
      rm: "Kah-veh!",
      en: "Be careful!",
    },
    {
      la: "Relinque me!",
      rm: "Reh-leen-kweh meh!",
      en: "Leave me alone!",
    },
    {
      la: "Esurio.",
      rm: "Eh-soo-ree-oh.",
      en: "I am hungry.",
    },
    {
      la: "Sitio.",
      rm: "See-tee-oh.",
      en: "I am thirsty.",
    },
    {
      la: "Me paenitet.",
      rm: "Meh pieh-nee-tet.",
      en: "I am sorry.",
    },
    {
      la: "Gratulor tibi!",
      rm: "Grah-too-lor tee-bee!",
      en: "Congratulations!",
    },
    {
      la: "Bonam fortunam!",
      rm: "Bo-nahm for-too-nahm!",
      en: "Good luck!",
    },
    {
      la: "Bonum iter!",
      rm: "Bo-noom ee-ter!",
      en: "Have a good trip!",
    },
    {
      la: "Prosit!",
      rm: "Pro-sit!",
      en: "Cheers!",
    },
    {
      la: "Estne hoc gratis?",
      rm: "Est-neh hok grah-tees?",
      en: "Is this free?",
    },
    {
      la: "Quid est verbum tesserae?",
      rm: "Kwid est ver-boom tes-seh-reh?",
      en: "What is the password?",
    },
    {
      la: "Licetne mihi photographema capere?",
      rm: "Lee-ket-neh mee-hee fo-toh-grah-feh-mah kah-peh-reh?",
      en: "May I take a photograph?",
    },
    {
      la: "Quid ais?",
      rm: "Kwid a-ees?",
      en: "What do you say?",
    },
    {
      la: "Quid dicis?",
      rm: "Kwid dee-kees?",
      en: "What are you saying?",
    },
    {
      la: "Tace!",
      rm: "Tah-keh!",
      en: "Be quiet!",
    },
    {
      la: "Festina lente!",
      rm: "Fes-tee-nah len-teh!",
      en: "Make haste slowly!",
    },
    {
      la: "Domus mea illic est",
      rm: "Do-moos meh-ah il-leek est",
      en: "My house is over there",
    },
    {
      la: "Hoc est iucundum",
      rm: "Hok est yoo-koon-doom",
      en: "This is enjoyable",
    },
    {
      la: "Hoc est molestum",
      rm: "Hok est mo-les-toom",
      en: "This is annoying",
    },
    {
      la: "Tempus fugit",
      rm: "Tem-poos foo-git",
      en: "Time flies",
    },
    {
      la: "Semper fidelis",
      rm: "Sem-per fee-deh-lees",
      en: "Always faithful",
    },
    {
      la: "In vino veritas",
      rm: "In vee-no veh-ree-tas",
      en: "In wine [there is] truth",
    },
    {
      la: "Deo gratias",
      rm: "Deh-oh grah-tee-ahs",
      en: "Thanks [be] to God",
    },
    {
      la: "Ad astra per aspera",
      rm: "Ad as-tra per as-peh-ra",
      en: "A rough road leads to the stars",
    },
  ],
};
